import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link, browserHistory } from 'react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cookie from 'react-cookie'
import * as actions from '../../actions'
import InputProfile from '../componentKit2/InputProfile'
import CheckboxOfert from '../componentKit/CheckboxOfert'
import RadioProfile from '../componentKit/RadioProfile'
import { api, host, domen } from '../../config.js'
import CSSModules from 'react-css-modules'
import styles from './signupValidationForm.css'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const FB = window.FB

class SignupValidationForm extends Component {
  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.width = '300px'
    }
  }

  componentDidMount() {
    const { change, email } = this.props

    if (email) {
      change('email', email)
    }

    document.addEventListener('DOMContentLoaded', function () {
      window.addEventListener('message', function (event) {
        if (event.data.name === 'okAuth') {
          browserHistory.push({ pathname: '/social/ok', query: { code: event.data.code } })
        }
      }, false)
    }, false)
  }

  render() {
    const { error, handleSubmit, sign, packageType, program, onSubmit, promo, isTest, errorGender } = this.props
    const { host } = sign
    const isAlfa = domen.isAlfa

    const loginVk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }

      window.location = `https://oauth.vk.com/authorize?client_id=5750682&scope=offline&redirect_uri=${host}/social/vk&display=page&response_type=code`
    }

    const loginOk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }

      const url = `https://connect.ok.ru/oauth/authorize?client_id=1248995328&scope=VALUABLE_ACCESS,LONG_ACCESS_TOKEN,PHOTO_CONTENT,GET_EMAIL&response_type=code&redirect_uri=${host}/social/ok`
      window.open(url, 'Odnoklassniki', 'width=700,height=400')
    }

    const redirectFb = () => {
      let uri

      if (program) {
        uri = encodeURI(`${host}/social/fb?type=${packageType},${program},${promo}`)
      } else {
        uri = encodeURI(`${host}/social/fb`)
      }

      window.location = encodeURI('https://www.facebook.com/dialog/oauth?client_id=602675109923486&redirect_uri=' + uri + '&response_type=token')
    }

    const loginFb = () => {
      const self = this
      FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
          const token = response.authResponse.accessToken
          const userId = response.authResponse.userID
          const payload = { userId, token }
          return fetch(`${api}/user/authenticate-social`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
          })
          .then(response => response.json())
          .then(json => {
            if (json.errorCode === 1 && json.data && json.data.authToken) {
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              self.props.setToken(json.data.authToken)
              browserHistory.push('/signup/pay')
            } else {
              redirectFb()
            }
          })
        } else {
          redirectFb()
        }
      }, { scope: 'email' })
    }

    return (

      <form  onSubmit={handleSubmit(onSubmit)} className={styles.entryBox}>

        { isTest ?
          <div>
            <div className={styles.errorGender}>{errorGender}</div>
            <div className={styles.genderAuth}>
              <p className="gender__title">Ваш пол:</p>
              <Field  notError={true} name="gender" value="male" type='radio' title="Мужчина" id="gender[1]" component={RadioProfile} />
              <Field  notError={true} name="gender" value="female" type='radio' title="Женщина" id="gender[2]" component={RadioProfile} />
            </div>
          </div>
          : null }



        <Field name='email' id='login[1]' placeholder='Ваш e-mail' component={InputProfile} />
        <Field name='password' id='login[2]' placeholder='Ваш пароль' type='password' component={InputProfile} />
        <Field name='passwordAgain' id='login[3]' placeholder='Пароль повторно' type='password' component={InputProfile} />


        { !isTest ?
          <div>
            <div className={styles.errorGender}>{errorGender}</div>
            <div className={styles.genderAuth}>
              <p className="gender__title">Ваш пол:</p>
              <Field notError={true} name="gender" value="male" type='radio' title="Мужчина" id="gender[1]" component={RadioProfile} />
              <Field notError={true} name="gender" value="female" type='radio' title="Женщина" id="gender[2]" component={RadioProfile} />
            </div>
            <hr className="gender__hr"/>
          </div>
          : null }

        { !isTest ?
          <div className={styles.checkboxes}>
            <Field checked ={isTest ? true : false} name='accept' title='Принять условия ' id='accept'  isTest ={isTest} component={CheckboxOfert} />
          </div>
          : null }

        {error && <strong>{error}</strong>}

        <button type='submit' className={isTest ? styles.buttonActionWide : isAlfa ? styles.buttonAlfaWide : styles.buttonSecondaryWide}>
          {!isTest ? 'Зарегистрироваться' : 'Зарегистрироваться и получить подарок'}
        </button>

        { isTest ?
          <div className={styles.checkboxes}>
            <Field checked ={true} name='accept' title='Принять условия ' id='accept'  isTest ={isTest} component={CheckboxOfert} />
          </div>
          : null }


        <hr className="gender__down"/>

        <ul className="entry-nav mtb20">
          <li className={styles.entryNavItem}>
            <Link to="/">Войти</Link>
          </li>
          <li className={styles.entryNavItem}>
            <Link to="/restore">Забыли пароль?</Link>
          </li>
        </ul>

        {/* <p className={styles.textCenterMb10}>Войти через социальные сети</p>

        <ul className={styles.socialSignin}>
          <li className={styles.socialSigninItemFb} onClick={loginFb}>
            <svg className={styles.svgIcoFb}>
              <use xlinkHref="#fb"></use>
            </svg>
          </li>
          <li className={styles.socialSigninItemVk} onClick={loginVk}>
            <svg className={styles.svgIcoVk}>
              <use xlinkHref="#vk"></use>
            </svg>
          </li>
          <li className={styles.socialSigninItemOk} onClick={loginOk}>
            <svg className={styles.svgIcoOk}>
              <use xlinkHref="#odnoklassniki"></use>
            </svg>
          </li>
        </ul> */}
      </form>
    )
  }
}

const validate = data => {
  const errors = {}

  if (data.email) {
    data.email = data.email.replace(/ /g, '')
  }

  switch (true) {
    case !data.email:
      errors.email = 'Email должен быть заполнен'
      break
    case !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(data.email):
      errors.email = 'Email заполнен неправильно, проверьте его еще раз'
      break
    default:
      break
  }

  switch (true) {
    case !data.password:
      errors.password = 'Поле пароля должно быть заполнено'
      break
    case data.password.length < 6:
      errors.password = 'Поле пароля должно быть длиннее 6 символов'
      break
    case data.password.length > 20:
      errors.password = 'Поле пароля должно быть короче 20 символов'
      break
    case /["]/g.test(data.password):
      errors.password = 'Поле пароля не должно содержать знак "'
      break
    default:
      break
  }

  if (data.password !== data.passwordAgain) {
    errors.passwordAgain = 'Пароли должны совпадать'
  }

  if (!data.gender) {
    errors.gender = 'Пол должен быть заполнен'
  }

  if (!data.accept) {
    errors.accept = 'Вы должны принять условия оферты и правил'
  }

  return errors
}

const asyncValidate = values => {
  return fetch(`${api}/user/user-check`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({ email: values.email })
  })
  .then(response => response.json())
  .then(json => {

    if (json.data) {
      throw { email: 'Такой email уже существует' }
    }
  })
}

SignupValidationForm = reduxForm({
  form: 'signupFormValidation',
  validate,
  asyncValidate,
  asyncBlurFields: [ 'email' ]
})(SignupValidationForm)

const mapStateToProps = state => {
  const {sign} = state
  let { program, packageType, promo } = state.profile

  return {
    program,
    sign,
    packageType,
    promo
  }
}

const mapDispatchToProps = dispatch => ({
  setToken: bindActionCreators(actions.setToken, dispatch)
})

SignupValidationForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupValidationForm)

export default CSSModules(SignupValidationForm, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/profile/SignupValidationForm.js